import { useEffect } from "react";

/**
 * Inject a JSON-LD structured-data block into <head> for the current page
 * and remove it on unmount. Multiple blocks per page are supported via
 * a stable `id` per block (any string).
 *
 * Rendered as <script type="application/ld+json" data-jsonld-id={id}>.
 * We use dangerouslySetInnerHTML style via textContent so React never
 * touches it and route changes stay clean.
 */
export const useJsonLd = (id, obj) => {
  useEffect(() => {
    if (!id || !obj) return undefined;
    const selector = `script[data-jsonld-id="${id}"]`;
    // Remove any leftover (e.g. HMR reruns).
    document.querySelectorAll(selector).forEach((n) => n.remove());
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-jsonld-id", id);
    try {
      el.textContent = JSON.stringify(obj);
    } catch (_e) {
      return undefined;
    }
    document.head.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [id, JSON.stringify(obj || null)]);
};

export default useJsonLd;
